import { render, staticRenderFns } from "./PrecedentCaseEditor.vue?vue&type=template&id=0ea7fc8e&scoped=true&"
import script from "./PrecedentCaseEditor.vue?vue&type=script&lang=js&"
export * from "./PrecedentCaseEditor.vue?vue&type=script&lang=js&"
import style0 from "./PrecedentCaseEditor.vue?vue&type=style&index=0&id=0ea7fc8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7fc8e",
  null
  
)

export default component.exports